import InvalidPasswordCharactersInlineMessage from './InvalidPasswordCharactersInlineMessage';

export default InvalidPasswordCharactersInlineMessage;
